import api                from '@/api'
import axios              from 'axios'
export default {
    data () {
        return {
        
                      
       
        }
      },
    methods: {
        sendTotalToSelfCash(total)
        {
            const url = JSON.parse(localStorage.getItem("selfCashUrl"))  
            if(url)
            {  
              const body = {'tipo' : 1,'importo' : total}            
              console.log('selfCashUrl',url)
              this.postToSelfCash(url,body)
              console.log('postSelfCash')
            }

        },
        
        async storeSelfCashApi(storeId,deskId)
        {
            localStorage.removeItem('selfCashUrl')

            const sp       = {'sp'      : 'spStoreSelfCashApi'}
            const data     = {'storeId' : storeId,'deskId':deskId}     
            const json     = Object.assign(data, sp)  
            
           await api.post(json).then(res => {
              
              if(res.data.recordsets[0].length > 0 )
              {
                localStorage.setItem('selfCashUrl',JSON.stringify(res.data.recordsets[0][0].api_url))                                
                
              }
              
           })
        },
        
        postToSelfCash(url,data)
        {
           
           axios({
                  url    : url,
                  method : "post",
                  data   : data,
                  headers : {'Content-type' : 'application/json; charset=utf-8'}
                  }).then(res => {
                    console.log(res.data)
                  }).catch(err => {
                    console.log(err)
    
                  })
        }, 
    }


    

}